/**
 * @generated SignedSource<<2f9753599d7fab9f5c325868305a3a73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnsubscribeEmailInput = {
  clientMutationId?: string | null;
  email: string;
  token: string;
};
export type UnsubscribeEmailMutation$variables = {
  input: UnsubscribeEmailInput;
};
export type UnsubscribeEmailMutation$data = {
  readonly unsubscribeEmail: {
    readonly clientMutationId: string | null;
  } | null;
};
export type UnsubscribeEmailMutation = {
  variables: UnsubscribeEmailMutation$variables;
  response: UnsubscribeEmailMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnsubscribeEmailPayload",
    "kind": "LinkedField",
    "name": "unsubscribeEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnsubscribeEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnsubscribeEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c5a32bea8830b30cbfd09776497311b7",
    "id": null,
    "metadata": {},
    "name": "UnsubscribeEmailMutation",
    "operationKind": "mutation",
    "text": "mutation UnsubscribeEmailMutation(\n  $input: UnsubscribeEmailInput!\n) {\n  unsubscribeEmail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcc606c907738fe5e54b913af665d115";

export default node;
